import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { logoutMerchantUser } from "../../api/userAuth";
import { logout } from "../../features/authSlice";
import { useNotify } from "../../context/NotifyContext";
import ConfirmDialog from "../ui/ConfirmDialog";

const LogoutPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { notify } = useNotify();
  const [open, setOpen] = useState(true);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setOpen(true);
  }, []);

  const handleYesLogout = async () => {
    setLoading(true);
    try {
      const res = await logoutMerchantUser();
      if (res?.success) {
        dispatch(logout());
        notify("Logged out successfully", "success");
        window.location.href = "/";
      } else {
        notify(res?.message || "Logout failed", "error");
        setLoading(false);
      }
    } catch (error) {
      console.error("Logout error:", error);
      notify("Something went wrong while logging out", "error");
      setLoading(false);
    }
  };

  return (
    <div className="w-full h-screen flex items-center justify-center bg-[color-mix(in_srgb,var(--text-dark)_35%,transparent)]">
      <ConfirmDialog
        open={open}
        title="Confirm Logout"
        message="Are you sure you want to logout from your account?"
        confirmLabel="Yes, Logout"
        cancelLabel="Cancel"
        confirmColor="error"
        loading={loading}
        onConfirm={handleYesLogout}
        onCancel={() => navigate("/dashboard")}
      />
    </div>
  );
};

export default LogoutPage;
